import React, {useState} from "react";

interface PersonSelectProps {
  id: string;
  persons: string[];
  pSNr: {[key: string]: number};
  setPSNr: React.Dispatch<React.SetStateAction<{[key: string]: number}>>;
  s: {[key: string]: string[]};
  setS: React.Dispatch<React.SetStateAction<{[key: string]: string[]}>>;
}

function PersonSelects(props: PersonSelectProps) {
  const { id, persons, pSNr, setPSNr, s, setS } = props;

  const [nrShown, setNrShown] = useState<number>(pSNr[id]);

  const show = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setNrShown(nrShown + 1);
    pSNr[id] = pSNr[id] + 1;
    setPSNr(pSNr);
  };

  const change = (e: React.ChangeEvent<HTMLSelectElement>, i: number) => {
    // s[id][i] = e.currentTarget.value
    s[id][i] = e.currentTarget.value;
    setS({...s, id: [...s[id]]});
  }

  const options = persons.map((p) => {
    return (<option key={p} value={p}>{p}</option>);
  });

  const letters = ['d', 'e', 'f', 'g'];
  let selects = [];
  for (let i = 0; i < nrShown; i++) {
    selects.push(
      (
        <div className="form-group focused" key={letters[i] + id}>
          <label htmlFor={letters[i] + id} className="control-label">
            Zuständige Person {(i + 1)}
          </label>
          <select id={letters[i] + id} className="personSelect form-control" value={s[id][i]} onChange={(e) => change(e, i)}>
            <option key="-" value="-" disabled hidden />
            {options}
            <option key="niemand" value="niemand">niemand</option>
          </select>
        </div>
      )
    );
  }

  return (
    <div className="personBlock__selects">
      {selects}
      {nrShown < 4 && (
        <button className="btn another-person" onClick={(e) => show(e)}>weitere Person</button>
      )}
    </div>
  );
}

export default PersonSelects;